import { IApplicationState, TReduxActions } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import { makeCreateStore } from '../../../../packages/redux-utils';
import { reducers } from '../../reducers';

export const createReduxStore = makeCreateStore<IApplicationState, IApplicationContext, TReduxActions>({
  name: 'feedback-frontend.FeedbackPage',
  reducer: reducers,
});
